export enum FaqType {
    OnboardingMessage = 1,
    Notification = 2,
    FAQ = 3,
}